import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/model/filterPanelService.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.assign.js";
import { createEvent, createStore } from 'effector';
import * as smApi from '@gmini/sm-api-sdk';
import { clone } from 'ramda';
import { useStore, useStoreMap } from 'effector-react';
import { allModelsSourceItem, noDependenciesErrorText } from "../constants";
import { FilterButton, FilterPanel } from "../components";
import { jsx as _jsx } from "react/jsx-runtime";
export function createFilterPanelService() {
  var addSources = createEvent({
    name: "addSources",
    sid: "-jzrg1l"
  });
  var removeSources = createEvent({
    name: "removeSources",
    sid: "xn5co8"
  });
  var setSources = createEvent({
    name: "setSources",
    sid: "gkl604"
  });
  var resetSources = createEvent({
    name: "resetSources",
    sid: "-ls8bnn"
  });
  var sources$ = createStore([], {
    name: "sources$",
    sid: "-xogyne"
  }).on(addSources, function (state, sources) {
    var nextState = state.filter(function (_ref) {
      var type = _ref.type;
      return type !== 'ALL_MODELS';
    });
    sources.forEach(function (source) {
      if (!nextState.find(function (_ref2) {
        var id = _ref2.id,
            type = _ref2.type;
        return id === source.id && type === source.type;
      })) {
        nextState.push(source);
      }
    });
    return nextState;
  }).on(removeSources, function (state, sources) {
    var nextState = _toConsumableArray(state);

    sources.forEach(function (source) {
      var index = nextState.findIndex(function (_ref3) {
        var id = _ref3.id,
            type = _ref3.type;
        return id === source.id && type === source.type;
      });

      if (index !== -1) {
        nextState.splice(index, 1);
      }
    });

    if (nextState.length === 0) {
      nextState.push(allModelsSourceItem);
    }

    return nextState;
  }).on(setSources, function (state, sources) {
    return sources;
  }).on(resetSources, function (state) {
    return [allModelsSourceItem];
  });
  var setFilterConditions = createEvent({
    name: "setFilterConditions",
    sid: "1jg2le"
  });
  var resetFilterConditions = createEvent({
    name: "resetFilterConditions",
    sid: "-jyx4sr"
  });
  var removeFilterConditions = createEvent({
    name: "removeFilterConditions",
    sid: "cwbcjr"
  });
  var addFilterConditions = createEvent({
    name: "addFilterConditions",
    sid: "pm1gn2"
  });
  var conditions$ = createStore([], {
    name: "conditions$",
    sid: "-wms5g"
  }).on(addFilterConditions, function (state, conditions) {
    return [].concat(_toConsumableArray(state), _toConsumableArray(conditions));
  }).on(removeFilterConditions, function (state, conditions) {
    var nextState = _toConsumableArray(state);

    conditions.forEach(function (condition) {
      var index = nextState.findIndex(function (_ref4) {
        var propertyName = _ref4.propertyName,
            propertyGroupName = _ref4.propertyGroupName;
        return propertyName === condition.propertyName && propertyGroupName === condition.propertyGroupName;
      });

      if (index !== -1) {
        nextState.splice(index, 1);
      }
    });
    return nextState;
  }).on(setFilterConditions, function (state, conditions) {
    return conditions;
  }).reset(resetFilterConditions);
  var openFilterPanel = createEvent({
    name: "openFilterPanel",
    sid: "-fa5h0"
  });
  var closeFilterPanel = createEvent({
    name: "closeFilterPanel",
    sid: "gh949j"
  }); //TODO убрать понятие FilterType, прокидывать все данные в фильтр снаружи

  var openedFilterPanel$ = createStore({
    open: false,
    type: 'global'
  }, {
    name: "openedFilterPanel$",
    sid: "t37jby"
  }).on(openFilterPanel, function (_state, result) {
    return result.type === 'folder' ? {
      open: true,
      type: result.type,
      groupName: result.groupName,
      groupId: result.groupId,
      hasFilterCondition: result.hasFilterCondition
    } : {
      open: true,
      type: result.type
    };
  }).on(closeFilterPanel, function () {
    return {
      open: false,
      type: 'global'
    };
  });
  var filterPropertyList$ = createStore([], {
    name: "filterPropertyList$",
    sid: "-crpdxs"
  }).on(smApi.UserClassifier.Property.List.fetchElementProperties.defaultContext.doneData, function (state, result) {
    return result.elementProperties;
  });
  var filterPropertyValuesMap$ = createStore({}, {
    name: "filterPropertyValuesMap$",
    sid: "-loaq9x"
  }).on(smApi.UserClassifier.Property.List.fetchElementPropertyValues.defaultContext.done, function (state, _ref5) {
    var params = _ref5.params,
        result = _ref5.result;
    var nextState = clone(state);
    nextState[params.propertyId] = (result === null || result === void 0 ? void 0 : result.values) || [];
    return nextState;
  });

  var useFilterPropertyValues = function useFilterPropertyValues(_ref6) {
    var propertyId = _ref6.propertyId;
    return useStoreMap({
      store: filterPropertyValuesMap$,
      keys: [propertyId],
      fn: function fn(propertyValues, _ref7) {
        var _ref8 = _slicedToArray(_ref7, 1),
            propertyId = _ref8[0];

        return propertyId ? propertyValues[propertyId] || [] : [];
      }
    });
  };

  var filterPanelService = {
    sources: {
      store$: sources$,
      add: addSources,
      remove: removeSources,
      set: setSources,
      reset: resetSources
    },
    conditions: {
      store$: conditions$,
      add: addFilterConditions,
      remove: removeFilterConditions,
      set: setFilterConditions,
      reset: resetFilterConditions
    },
    filterPropertyList$: filterPropertyList$,
    filterPropertyValuesMap$: filterPropertyValuesMap$,
    useFilterPropertyValues: useFilterPropertyValues,
    openedFilterPanel$: openedFilterPanel$,
    closeFilterPanel: closeFilterPanel,
    openFilterPanel: openFilterPanel
  };

  var FilterPanelComp = function FilterPanelComp(_ref9) {
    var props = Object.assign({}, _ref9);
    return /*#__PURE__*/_jsx(FilterPanel, _objectSpread(_objectSpread({}, props), {}, {
      filterPanelService: filterPanelService,
      onClose: function onClose() {
        return filterPanelService.closeFilterPanel();
      }
    }));
  };

  var FilterButtonComp = function FilterButtonComp(_ref10) {
    var _currentUserClassifie;

    var searchModel = _ref10.searchModel,
        currentUserClassifier = _ref10.currentUserClassifier;
    var openedFilterPanel = useStore(openedFilterPanel$, {
      loc: {
        file: _effectorFileName,
        line: 196,
        column: 30
      },
      name: "FilterButtonComp",
      sid: "FilterButtonComp /src/components/FilterPanel/model/filterPanelService.tsx [196, 30]"
    });
    var searchNodes = useStore(searchModel.searchNodes$, {
      loc: {
        file: _effectorFileName,
        line: 197,
        column: 24
      },
      name: "FilterButtonComp",
      sid: "FilterButtonComp /src/components/FilterPanel/model/filterPanelService.tsx [197, 24]"
    });
    return /*#__PURE__*/_jsx(FilterButton, {
      onClick: function onClick() {
        if (openedFilterPanel.open) {
          if (openedFilterPanel.type === 'folder') {
            filterPanelService.openFilterPanel({
              type: 'global'
            });
            return;
          }

          filterPanelService.closeFilterPanel();
          return;
        }

        if (!openedFilterPanel.open) {
          filterPanelService.openFilterPanel({
            type: 'global'
          });
        }
      },
      error: currentUserClassifier !== null && currentUserClassifier !== void 0 && (_currentUserClassifie = currentUserClassifier.sourceClassifiers) !== null && _currentUserClassifie !== void 0 && _currentUserClassifie.length ? '' : noDependenciesErrorText,
      active: openedFilterPanel.open && openedFilterPanel.type === 'global',
      applied: Boolean(openedFilterPanel.type === 'global' && (searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.type) === 'filter' && searchNodes.nodes.length)
    });
  };

  return _objectSpread(_objectSpread({}, filterPanelService), {}, {
    FilterPanel: FilterPanelComp,
    FilterButton: FilterButtonComp
  });
}